<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { computed } from 'vue';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// 여러 키를 확인하여 로고 URL 찾기
const logoUrl = computed(() => {
  const config = globalConfig.value || {};
  // 여러 가능한 키 이름 확인
  return config.logoThumbnail 
    || config.LOGO_THUMBNAIL
    || config.logo
    || config.LOGO
    || null;
});
</script>

<template>
  <img
    v-if="logoUrl"
    v-bind="attrs"
    :src="logoUrl"
    alt="STEINON"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="steinon-logo">
      <!-- 작은 사각형 (왼쪽) - 오른쪽 선이 없음 -->
      <path
        d="M 0 8 L 0 24 L 12 24 L 12 8"
        fill="none"
        stroke="#2B3A47"
        stroke-width="1.5"
      />
      <!-- 큰 사각형 (오른쪽) - 왼쪽 선이 없음 -->
      <path
        d="M 12 8 L 32 8 L 32 24 L 12 24"
        fill="none"
        stroke="#2B3A47"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
